<template>
    <div class="modal fade" id="joinUs" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog become_custome__modal" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Join Us</h5>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" @click="resetForm">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="submitApplication">
                        <div class="become_custome__form">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="input-field">
                                        <input type="text" placeholder="Name"
                                            v-model="applicationForm.candidateName" />
                                            <div class="error-msg" v-if="applicationErrors.candidateName">{{ applicationErrors.candidateName }}</div>
                                  
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input-field">
                                        <input type="email" placeholder="Email"
                                            v-model="applicationForm.email" />
                                            <div class="error-msg" v-if="applicationErrors.email">{{ applicationErrors.email }}</div>
                                    
                           
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input-field">
                                        <select class="selectbox" v-model="applicationForm.designation">
                                            <option value="">Select Job</option>
                                            <option v-for="category in jobCategories" :key="category.id"
                                                :value="category.title">
                                                {{ category.title }}
                                            </option>
                                        </select>
                                        <div class="error-msg" v-if="applicationErrors.designation">{{ applicationErrors.designation }}</div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input-field">
                                        <input type="text" placeholder="Name of your Reference (if any)"
                                            v-model="applicationForm.nameOfReference" />
                                            
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="browse-input">
                                        <div class="browse-field">
                                            <div class="browse-button company-logo">Images</div>
                                            <input type="file" @change="handleFileUpload($event)" accept="image/jpeg,image/jpg,image/png" :key="fileInputKey" />
                                            <!-- <div class="error-msg" v-if="!selectedImageFile">{{ errMsg }}</div> -->

                                        </div>
                                        <div class="browsed-img" v-if="imageUploaded"><img :src="imageUrl" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="browse-input">
                                        <div class="browse-field">
                                            <div class="browse-button company-logo">Resume</div>
                                            <input type="file" @change="handleResumeUpload($event)" accept=".pdf" :key="fileInputKey" />
                                            <div class="error-msg" v-if="!selectedResumeFile && applicationErrors.candidateResume">{{ applicationErrors.candidateResume }}</div>

                                        </div>
                                        <div class="browsed-img" v-if="resumeUploaded">{{ ResumeName }}</div>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="input-field"> <textarea placeholder="Details"
                                            v-model="applicationForm.description"></textarea>
                                            
                                        </div>
                                </div>
                                <div class="col-sm-12">
                                    <div
                                    id="captchaWidget"
                                    class="g-recaptcha"
                                    ></div>
                                    <div class="error-msg" v-if="recaptchaError">
                                    {{ recaptchaError }}
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="primary-btn-outline" >{{ isSubmitting ? 'Submitting...' : 'Submit' }}</button>
                            <button type="button" class="dummy-btn" data-bs-dismiss="modal" ref="dummyButton"
                                style="display: none;"></button>
                            <button type="button" class="primary-btn-outline" @click="resetForm">Reset</button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '@/config/api.config';
import { loadRecaptchaScript } from '@/utils/captcha';

declare global {
  interface Window {
    grecaptcha: {
      ready: (callback: () => void) => void;
      render: (
        container: string | HTMLElement,
        parameters: {
          sitekey: string;
          callback?: (token: string) => void;
          "expired-callback"?: () => void;
          theme?: "light" | "dark";
          size?: "normal" | "compact";
        }
      ) => number;
      reset: (widgetId?: number) => void;
      getResponse: (widgetId?: number) => string;
    };
    onRecaptchaLoad?: () => void;
    recaptchaCallbacks?: Array<() => void>;
  }
}

interface ApplicationForm {
    candidateName: string;
    email: string;
    designation: string;
    nameOfReference: string | null;
    candidateImage: string | null;
    candidateResume: File | null;
    description: string | null;
}

export default defineComponent({
    name: "jobForm",
    data() {
        return {
            applicationForm: {
                candidateName: '',
                email: '',
                designation: '',
                nameOfReference: null,   // Changed to null to indicate optional
                candidateImage: null,
                candidateResume: null,
                description: null        // Changed to null to indicate optional
            } as ApplicationForm,
            jobCategories: [] as any,
            imageSrc: '',
            selectedImageFile: null as File | null,
            imageUploaded: false,
            selectedResumeFile: null as File | null,
            errMsg: '',
            ResumeName: '',
            resumeUploaded: false,
            fileInputKey: 0,
            applicationErrors: {
            candidateName: '',
            email: '',
            designation: '',
            candidateResume:''
            }, // Replace errMsg with this
            isSubmitting: false,  // New flag to track submission state
            recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY!,
            recaptchaToken: "",
            recaptchaWidgetId: null as number | null,
            recaptchaError: "",
        }
    },
    computed: {
        imageUrl(): string {
            return this.imageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
    },
    mounted() {
        loadRecaptchaScript(this.onRecaptchaLoad.bind(this));
        this.getJobCategories();
    },

    beforeUnmount() {
        this.cleanupRecaptcha();
    },
    methods: {

        isValidEmail(email: string): boolean {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
            },
        async submitApplication() {
            
            // If already submitting, prevent further submissions
            if (this.isSubmitting) {
                return;
            }

            this.applicationErrors = {
                candidateName: '',
                email: '',
                designation: '',
                candidateResume:''
            };
            let hasErrors = false;

            // Validate only required fields
            if (!this.applicationForm.candidateName) {
                this.applicationErrors.candidateName = 'Please enter a name';
                hasErrors = true;
            }
            if (!this.applicationForm.email) {
                this.applicationErrors.email = 'Please enter an email address';
                hasErrors = true;
            } else if (!this.isValidEmail(this.applicationForm.email)) {
                this.applicationErrors.email = 'Please enter a valid email address';
                hasErrors = true;
            }
            if (!this.applicationForm.designation) {
                this.applicationErrors.designation = 'Please select a job';
                hasErrors = true;
            }
            if (!this.selectedResumeFile) {
                this.applicationErrors.candidateResume = 'Please upload your resume.';
                hasErrors = true;
            }
            if (!this.recaptchaToken) {
                this.recaptchaError = 'Please verify you are not a robot.';
                hasErrors = true;
            }

            // If there are errors in required fields, stop submission
            if (hasErrors) {
                if (
                    !this.recaptchaToken &&
                    window.grecaptcha &&
                    this.recaptchaWidgetId !== null
                ) {
                    window.grecaptcha.reset(this.recaptchaWidgetId);
                }
                return;
            }
            
            // Set submitting flag to true to disable the button
            this.isSubmitting = true;

            const formData = new FormData();
            formData.append('candidateName', this.applicationForm.candidateName);
            formData.append('email', this.applicationForm.email);
            formData.append('designation', this.applicationForm.designation);

            // Only append optional fields if they have values
            if (this.applicationForm.nameOfReference) {  // Check if nameOfReference is provided
                formData.append('nameOfReference', this.applicationForm.nameOfReference);
            }
            if (this.selectedImageFile) {  // Check if an image file is selected
                formData.append('candidateImage', this.selectedImageFile);
            }
            if (this.selectedResumeFile) {  // Check if a resume file is selected
                formData.append('candidateResume', this.selectedResumeFile);
            }
            if (this.applicationForm.description) {  // Check if description is provided
                formData.append('description', this.applicationForm.description);
            }
            formData.append('recaptchaToken', this.recaptchaToken);
            formData.append('isDirectApply', "true");
            try {
                const response = await axios.post(`${API_BASE_URL}/candidates/`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                this.resetForm();
                this.imageUploaded = false;
                this.resumeUploaded = false;
                (this.$refs.dummyButton as HTMLElement).click();
                Swal.fire({
                    icon: 'success',
                    title: 'Form Submitted Successfully!',
                    showConfirmButton: false,
                    timer: 1500
                });
            } catch (error : any) {
                console.log(error);
                Swal.fire({
                icon: 'error',
                title: 'Submission Failed',
                text: error?.response?.data.error || 'Something went wrong. Please try again.',
                showConfirmButton: true
                });
            }
             finally {
                // Reset submitting flag after the request completes (success or failure)
                this.isSubmitting = false;
                if (window.grecaptcha && this.recaptchaWidgetId !== null) {
                window.grecaptcha.reset(this.recaptchaWidgetId);
                }
            }

        },
        resetForm(){
            this.applicationForm={
                candidateName: '',
                email: '',
                designation: '',
                nameOfReference: null,   // Reset to null for optional field
                candidateImage: null,
                candidateResume: null,
                description: null        // Reset to null for optional field
            },
            this.selectedImageFile=null,
            this.selectedResumeFile=null,
            this.imageSrc = '';
            this.imageUploaded=false;
            this.resumeUploaded=false;
            this.ResumeName='';   
            this.fileInputKey++;
            this.applicationErrors = {
                candidateName: '',
                email: '',
                designation: '',
                candidateResume:''
            };
            if (
                window.grecaptcha &&
                document.getElementById("captchaWidget") &&
                this.recaptchaWidgetId !== null
            ) {
                console.log("Resetting reCAPTCHA widget for Join Us");
                try {
                window.grecaptcha.reset(this.recaptchaWidgetId);
                this.recaptchaWidgetId = null;
                this.recaptchaError = "";
                } catch (error) {
                console.error("Error resetting reCAPTCHA:", error);
                this.recaptchaWidgetId = null;
                }
            }

        },        async getJobCategories() {
            try {
                const response = await axios.get(`${API_BASE_URL}/jobcategory/?status=1`);
                this.jobCategories = response.data;
            } catch (error) {
                console.error('Error fetching job categories:', error);
            }
        },
        handleFileUpload(event: any) {
            const target = event.target as HTMLInputElement;
            if (target && target.files && target.files.length > 0) {
                const file = target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    if (e.target && typeof e.target.result === 'string') {
                        this.imageSrc = e.target.result;
                        this.selectedImageFile = file;
                        this.imageUploaded = true

                    }
                };
            }
        },
        handleResumeUpload(event: Event) {
            const target = event.target as HTMLInputElement;
            const file = target.files?.[0];
            if (file) {
                this.selectedResumeFile = file;
                this.ResumeName=this.selectedResumeFile.name;
                this.resumeUploaded = true;
            }
        },
        cleanupRecaptcha() {
            if (window.grecaptcha && this.recaptchaWidgetId !== null) {
                console.log("Cleaning up reCAPTCHA widget for Join Us");
                try {
                window.grecaptcha.reset(this.recaptchaWidgetId);
                this.recaptchaWidgetId = null;
                this.recaptchaToken = "";
                this.recaptchaError = "";
                } catch (error) {
                console.error("Error cleaning up reCAPTCHA:", error);
                this.recaptchaWidgetId = null;
                }
            }
        },

        onRecaptchaLoad() {
            console.log("reCAPTCHA script loaded for Join Us");
            this.renderRecaptcha();
        },

        renderRecaptcha() {
            const widgetElement = document.getElementById(
                "captchaWidget"
            );
            if (window.grecaptcha && widgetElement) {
                console.log("Rendering reCAPTCHA widget for Join Us");
                try {
                window.grecaptcha.ready(() => {
                    // Only render if widgetId is null and element is empty
                    if (
                    this.recaptchaWidgetId === null &&
                    !widgetElement.hasChildNodes()
                    ) {
                    this.recaptchaWidgetId = window.grecaptcha.render(
                        "captchaWidget",
                        {
                        sitekey: this.recaptchaSiteKey,
                        callback: this.onRecaptchaSuccess.bind(this),
                        "expired-callback": this.onRecaptchaExpired.bind(this),
                        }
                    );
                    this.recaptchaError = "";
                    } else {
                    console.log(
                        "reCAPTCHA widget already rendered or element not empty"
                    );
                    }
                });
                } catch (error) {
                console.error("Error rendering reCAPTCHA:", error);
                this.recaptchaError = "Failed to render reCAPTCHA. Please try again.";
                }
            } else {
                console.error("grecaptcha or captchaWidget not available");
                this.recaptchaError = "reCAPTCHA not available. Please try again.";
            }
        },

        onRecaptchaSuccess(token: string) {
            console.log("reCAPTCHA verified for Join Us, token:", token);
            this.recaptchaToken = token;
            this.recaptchaError = "";
        },

        onRecaptchaExpired() {
            console.log("reCAPTCHA expired for Join Us");
            this.recaptchaToken = "";
            this.recaptchaError = "reCAPTCHA has expired. Please try again.";
        },
    }
});
</script>
